import { Box } from '@mui/material';
import { useColorMode } from '../../../hooks/colorModeProvider';
import LogoLight from '../../../resources/assets/images/bowlscout_logo_text_under.png';
import LogoDark from '../../../resources/assets/images/bowlscout_logo_text_under_white.png';

// Branding shown while the app or a portal session is loading. Keep every
// loading screen on this component so they stay in step.
const LoaderBrand = ({ width = 192 }) => {
  const { mode } = useColorMode();

  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      <img src={mode === 'dark' ? LogoDark : LogoLight} alt="BowlScout" width={width} />
    </Box>
  );
};

export default LoaderBrand;
